import styled, { css } from "styled-components";
import { Highlight } from "components/Hightlight/Hightlight.style";

export const YourIdeasContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  margin-bottom: 120px;

  ${(props) =>
    props.$textColor &&
    css`
      color: ${props.$textColor};
    `}

  @media screen and (max-width: 1200px) {
    gap: 32px;
    margin-bottom: 40px;
  }
  @media screen and (max-width: 768px) {
    gap: 0px;
  }
`;

export const YourIdeasText = styled.p`
  font-size: 32px;
  font-weight: 400;
  margin: 0px 10px;
  letter-spacing: -0.5px;
  line-height: 150%;

  & ${Highlight} {
    font-stretch: normal;
  }

  @media screen and (max-width: 1024px) {
    font-size: 28px;
    width: 100%;
    margin: 0px;
  }
  @media screen and (max-width: 768px) {
    padding-bottom: 32px;
    font-size: 20px;
    letter-spacing: 0px;
  }
`;
